var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustedLeaders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.44277L1.49648 3.3377C1.34883 3.41152 1.25039 3.53457 1.275 3.65762C1.275 5.92168 2.21016 9.80996 5.85234 11.5326C5.95078 11.5818 6.04922 11.5818 6.12305 11.5326C9.76523 9.78535 10.7004 5.92168 10.725 3.65762C10.725 3.53457 10.6266 3.41152 10.5035 3.3377L6 1.44277ZM6.31992 0.286132L10.9465 2.25488C11.4879 2.50098 11.9063 3.01777 11.9063 3.65762C11.8816 6.11855 10.8727 10.5729 6.63984 12.6154C6.22148 12.8123 5.75391 12.8123 5.33555 12.6154C1.10273 10.5729 0.0937498 6.11855 0.0937498 3.65762C0.0691404 3.01777 0.4875 2.50098 1.02891 2.25488L5.65547 0.286132C5.75391 0.236914 5.87695 0.212304 6 0.212304C6.09844 0.212304 6.22148 0.236914 6.31992 0.286132Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedLeaders);
export default __webpack_public_path__ + "static/media/trusted-leaders.914f575a124131a4dd7e6ce7e9d62e79.svg";
export { ForwardRef as ReactComponent };